module.exports = __webpack_public_path__ + "static/media/headerLogo.e8f45e77.png";